import AxiosService from '../../gateway/rest/AxiosService'

class O365SettingsRestService {
  static getO365BaseSettings(): Promise<any> {
    return AxiosService.get('/o365/settings/getO365BaseSettings')
  }

  static getSpAndOdSettings(): Promise<any> {
    return AxiosService.get('/o365/settings/getO365SharePointAndOneDriveSettings')
  }

  static configureO365Settings(o365Settings: any): Promise<any> {
    return AxiosService.put('/o365/settings/updateO365BaseSettings', o365Settings)
  }

  static configureSpAndOdSettingsSettings(spAndOdSettings: any): Promise<any> {
    return AxiosService.put('/o365/settings/updateO365SharePointAndOneDriveSettings', spAndOdSettings)
  }
}

export default O365SettingsRestService
